<div id="modal-decision">
    <div class="modal-header border-0">
        <button type="button" class="btn-close" aria-label="Close" data-dismiss="modal-decision" (click)="cerrar()"></button>
    </div>
    <div class="modal-body text-start pt-0">
        <h4>{{mensaje}}</h4>
        <div class="row">
            <div class="col-6">
                <div class="mb-3">
                    <label class="form-label" for="fecha">Fecha</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" ngbDatepicker [formControl]="fechaControl"
                            id="fecha" #dModal="ngbDatepicker" />
                        <button class="btn btn-outline-secondary" (click)="dModal.toggle()" type="button">
                            <app-svg-icon icon="calendar-event"></app-svg-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="col-6 px-0">
                    <div class="mb-3">
                        <label class="form-label" for="horaModal">Hora</label>
                        <ngb-timepicker [formControl]="horaControl" id="horaModal" [spinners]="false"></ngb-timepicker>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="mb-3">
                    <input type="checkbox" [formControl]="autodisableControl" id="disableModal" > Deshabilitar automaticamente
                </div>
            </div>
        </div>

    </div>

    <div class="modal-footer border-0">
        <button id="neoBtnCancel" type="button" class="btn btn-secondary" (click)="cerrar()">CANCELAR</button>
        <button id="neoBtnAccept" type="button" class="btn btn-primary" (click)="enviar()">ACEPTAR</button>
    </div>
</div>
